import { Component, Inject, ViewEncapsulation } from '@angular/core';

import { SnQuillEditorComponent } from '@components/common/sn-quill-editor/sn-quill-editor';
import { FileUploadDataProvider } from '@services/files/file-upload.data.service';
import { FileUploadServiceProvider } from '@services/files/file-upload-service/file-upload.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { Subject } from 'rxjs';
import { SNModalService } from '@web-services/modal/snModal.service';
import { SnQuillLinkModal } from '@web-components/common/sn-quill-editor/modals/sn-quill-link-modal/sn-quill-link-modal';
import { Subscription } from 'rxjs/Subscription';
import { SnQuillAttachmentModal } from '@web-components/common/sn-quill-editor/modals/sn-quill-attachment-modal/sn-quill-attachment.modal';
import { DOCUMENT } from '@angular/common';

@Component({
	selector: 'sn-quill-editor-web',
	template: require('./sn-quill-editor-web.html'),
	styles: [require('./sn-quill-editor-web.scss')],
	encapsulation: ViewEncapsulation.None
})
export class SnQuillEditorWebComponent extends SnQuillEditorComponent {
	unsubscribe: Subject<void> = new Subject();
	private linkdData$: Subscription;

	attachmentsOption: Array<any> = [
		{ attachments: ['From Files', 'From Computer'] }
	];

	constructor(
		private fileUploadDataService: FileUploadDataProvider,
		fileUploadService: FileUploadServiceProvider,
		messageService: MessageService,
		private modalService: SNModalService,
		@Inject(DOCUMENT) private document: Document
	) {
		super(fileUploadDataService, fileUploadService, messageService);
	}

	attachmentsHandler(type: string): void {
		this.attachmentSelector = `#attachment-${this.editorID}`;
		if (type === 'From Files' && this.isStoredFiles) {
			this.showChooseFileModal();
		} else if (type === 'From Computer') {
			this.attachFileFromComputer();
		}
	}

	/* Attachments */
	showChooseFileModal(): void {
		this.modalService.openModal(SnQuillAttachmentModal);
	}

	checkJobFiles(): void {
		this.fileUploadDataService.filesObservable
			.takeUntil(this.unsubscribe)
			.subscribe((storedFiles: Array<any>) => {
				this.isStoredFiles = !!storedFiles.length;
				if (this.isStoredFiles) {
					this.enableAttachments();
				} else {
					this.disabledAttachmentsFromFiles();
				}
			});
	}

	// TODO need refactor
	private enableAttachments(): void {
		let openDropDown = false;
		const attachmentsToolbarBtn = this.toolbar.querySelector('.ql-attachments');

		if (attachmentsToolbarBtn === null) {
			return;
		}
		attachmentsToolbarBtn.addEventListener('click', () => {
			openDropDown = !openDropDown;
			if (openDropDown) {
				const fromFilesOption = this.toolbar.querySelector(
					'.ql-picker-item[data-value="From Files"]'
				);
				if (fromFilesOption.classList.contains('disableOption')) {
					fromFilesOption.classList.remove('disableOption');
				}
			}
		});
	}

	openLinkModal(delta?): void {
		// Open modal
		const modal = this.modalService.openModal(SnQuillLinkModal, {
			windowClass: 'ng-bootstrap-modal__small'
		});

		// Pass delta as an input
		modal.componentInstance.delta = delta;

		// Subscribe for data to come on modal close
		this.linkdData$ = this.modalService.getModalData().subscribe(modalData => {
			if (modalData) {
				this.successCloseLinkModal(modalData, delta);
			}
			this.linkdData$.unsubscribe();

			this.tooltip.classList.remove('removeTooltip');

			this.clear();
		});
	}

	insertIntoQuill(data): void {
		if (data) {
			const cursorPosition = this.getCursorPosition();
			this.quill.insertText(
				cursorPosition,
				data.text,
				'link',
				data.url,
				'user'
			);
			this.setCursorPosition(data.text.length, cursorPosition);
		}
	}

	private clear(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	updateLink(delta, data): void {
		if (!delta.url) {
			const cursorPos = this.getCursorPosition();
			this.quill.updateContents(
				[
					{ retain: cursorPos || 1 },
					{ delete: data.text.length },
					{ insert: data.text, attributes: { link: data.url } }
				],
				'user'
			);
		} else {
			const pos = this.quill.getSelection();
			let leaf = this.quill.getLeaf(pos.index)[0];
			let elem = leaf.domNode.parentElement;
			let isLink = elem && elem.tagName === 'A';
			let isStyledLink =
				elem &&
				(elem.tagName === 'STRONG' ||
					elem.tagName === 'EM' ||
					elem.tagName === 'U');

			if (!isLink && !isStyledLink) {
				leaf = this.quill.getLeaf(pos.index + 1)[0];
				elem = leaf.domNode.parentElement;
				isLink = elem && elem.tagName === 'A';
				isStyledLink =
					elem &&
					(elem.tagName === 'STRONG' ||
						elem.tagName === 'EM' ||
						elem.tagName === 'U');
			}

			if (isLink) {
				this.updateLeafByLink(data, elem);
			}
			if (isStyledLink) {
				this.updateLeafByLink(data, elem.parentElement);
			}
		}
	}

	private successCloseLinkModal(linkModal, delta?): void {
		this.quill.focus();
		const modalData = linkModal;
		const editExisting = modalData && (delta.text && delta.url);
		const createFromExisting = modalData && (delta.text && !delta.url);
		const insertNew = modalData && (!delta.text && !delta.url);
		this.checkIfEmail(modalData);

		if (insertNew) {
			this.insertIntoQuill(modalData);
		}

		if (editExisting || createFromExisting) {
			this.updateLink(delta, modalData);
		}
	}

	private checkIfEmail(linkData): void {
		if (linkData.isEmail) {
			linkData.url = `mailto:${linkData.url}`;
		}
	}

	private updateLeafByLink(data, elem): void {
		elem.setAttribute('href', data.url);
		elem.textContent = data.text;
		this.setCursorPosition(data.text.length, this.quill.getSelection().index);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/common/sn-quill-editor/sn-quill-editor-web.ts